export default __webpack_public_path__ + "static/media/10.376d3b53.jpg";